export default [
	{
		code: 'MR001',
		description: 'ACER'
	},
	{
		code: 'MR002',
		description: 'AEG'
	},
	{
		code: 'MR003',
		description: 'APPLE'
	},
	{
		code: 'MR004',
		description: 'ARISTON'
	},
	{
		code: 'MR005',
		description: 'ASPES'
	},
	{
		code: 'MR006',
		description: 'ASUS'
	},
	{
		code: 'MR007',
		description: 'BALAY'
	},
	{
		code: 'MR008',
		description: 'BOSCH'
	},
	{
		code: 'MR009',
		description: 'CANDY'
	},
	{
		code: 'MR010',
		description: 'CARRIER'
	},
	{
		code: 'MR011',
		description: 'CHAFOTEAUX'
	},
	{
		code: 'MR012',
		description: 'COINTRA'
	},
	{
		code: 'MR013',
		description: 'CORBERO'
	},
	{
		code: 'MR014',
		description: 'DAEWOO'
	},
	{
		code: 'MR015',
		description: 'DELL'
	},
	{
		code: 'MR016',
		description: 'DESCONOCIDA'
	},
	{
		code: 'MR017',
		description: 'EDESA'
	},
	{
		code: 'MR018',
		description: 'ELECTROLUX'
	},
	{
		code: 'MR019',
		description: 'FAGOR'
	},
	{
		code: 'MR020',
		description: 'FERROLI'
	},
	{
		code: 'MR021',
		description: 'FIRST LINE'
	},
	{
		code: 'MR022',
		description: 'FLECK'
	},
	{
		code: 'MR023',
		description: 'FUJITSU'
	},
	{
		code: 'MR024',
		description: 'GENERAL ELECTRIC'
	},
	{
		code: 'MR025',
		description: 'GRUNDING'
	},
	{
		code: 'MR026',
		description: 'HITACHI'
	},
	{
		code: 'MR027',
		description: 'HP-COMPAQ'
	},
	{
		code: 'MR028',
		description: 'HUAWEI'
	},
	{
		code: 'MR029',
		description: 'IGNIS'
	},
	{
		code: 'MR030',
		description: 'INDESIT'
	},
	{
		code: 'MR031',
		description: 'JATA'
	},
	{
		code: 'MR032',
		description: 'JHONSON'
	},
	{
		code: 'MR033',
		description: 'JUNKER'
	},
	{
		code: 'MR034',
		description: 'LG'
	},
	{
		code: 'MR035',
		description: 'LIEBHER'
	},
	{
		code: 'MR036',
		description: 'LOEWE'
	},
	{
		code: 'MR037',
		description: 'LYNX'
	},
	{
		code: 'MR038',
		description: 'MEPANSA'
	},
	{
		code: 'MR039',
		description: 'MIELE'
	},
	{
		code: 'MR040',
		description: 'MITSUBISHI'
	},
	{
		code: 'MR041',
		description: 'NEW POOL'
	},
	{
		code: 'MR042',
		description: 'NODOR'
	},
	{
		code: 'MR043',
		description: 'OTROS'
	},
	{
		code: 'MR044',
		description: 'OTSEIN'
	},
	{
		code: 'MR045',
		description: 'PACKARD BELL'
	},
	{
		code: 'MR046',
		description: 'PANASONIC'
	},
	{
		code: 'MR047',
		description: 'PHILLPS'
	},
	{
		code: 'MR048',
		description: 'ROCA'
	},
	{
		code: 'MR049',
		description: 'SAIVOD'
	},
	{
		code: 'MR050',
		description: 'SAMSUNG'
	},
	{
		code: 'MR051',
		description: 'SANYO'
	},
	{
		code: 'MR052',
		description: 'SAUNIER DUVAL'
	},
	{
		code: 'MR053',
		description: 'SHARP'
	},
	{
		code: 'MR054',
		description: 'SIEMENS'
	},
	{
		code: 'MR055',
		description: 'SONY'
	},
	{
		code: 'MR056',
		description: 'TEKA'
	},
	{
		code: 'MR057',
		description: 'TELEFUNKEN'
	},
	{
		code: 'MR058',
		description: 'THOMSON'
	},
	{
		code: 'MR059',
		description: 'THOSIBA'
	},
	{
		code: 'MR060',
		description: 'TOSHIBA'
	},
	{
		code: 'MR061',
		description: 'VAILLANT'
	},
	{
		code: 'MR062',
		description: 'WESTINGHOUSE'
	},
	{
		code: 'MR063',
		description: 'WHIRLPOOL'
	},
	{
		code: 'MR064',
		description: 'ZANUSSI'
	}
];
